// extracted by mini-css-extract-plugin
export default {"skeleton-loader":"t53a78W","gradient":"OKZDEB7","skeleton-loader--pill":"gJPzEcn"};